export default __webpack_public_path__ + "static/hero-video-bg-poster-9137a0aab47a96833ffbe53c0401fe0e.jpg";